import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [f, setF] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(f); nav("/"); toast.success("Welcome to Nisa Libas"); }
    catch (err) { toast.error(err.response?.data?.detail || "Registration failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="eyebrow mb-2 text-center">Account</div>
      <h1 className="font-serif text-3xl md:text-4xl text-[#0B1F3A] text-center mb-8">Create account</h1>
      <form onSubmit={submit} className="space-y-4 bg-white p-6 gold-border">
        {["name","email","phone","password"].map((k) => (
          <label key={k} className="block">
            <div className="text-xs text-[#1E293B]/60 mb-1 capitalize">{k}</div>
            <input type={k === "password" ? "password" : k === "email" ? "email" : "text"} required={k !== "phone"}
              value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })}
              className="w-full border px-3 py-2.5" style={{ borderColor: "rgba(212,175,55,0.4)" }} data-testid={`reg-${k}`} />
          </label>
        ))}
        <button disabled={busy} className="w-full bg-[#0B1F3A] text-[#FFF9E6] py-3 tracking-widest uppercase text-sm disabled:opacity-60" data-testid="register-submit">{busy ? "…" : "Create account"}</button>
        <div className="text-xs text-center text-[#1E293B]/60">Already have one? <Link to="/login" className="underline text-[#0B1F3A]" data-testid="to-login">Sign in</Link></div>
      </form>
    </div>
  );
}
